import React, { useState, useEffect } from 'react';

export default function UserProfile() {
  return (
    <div className='container'>
      <h1>Here's where the profile would go</h1>
    </div>
  );
}
